import React from 'react'
import { Box, Text, Stack } from '@chakra-ui/react'
import { IntermediaryAddress } from './types'
import { Address } from '@Types'

export interface BeneficiaryBankSectionProps {
  bankName?: string
  bankSWIFTBIC?: string
  bankAddress: Address
  additionalInformation?: string
  intermediateBankAddress: IntermediaryAddress
  isInternationalBank: boolean
  isIntermediaryAccount?: boolean
  isThirdParty?: boolean
}

const BeneficiaryBankSection = ({
  bankName = '',
  bankSWIFTBIC = '',
  isIntermediaryAccount,
  isInternationalBank,
  bankAddress,
  intermediateBankAddress,
  isThirdParty
}: BeneficiaryBankSectionProps) => {
  const {
    name,
    accountNumber,
    address,
    addressLine2,
    city,
    stateProvince,
    postalCode,
    country
  } = intermediateBankAddress
  return (
    <Stack spacing={2}>
      <Text as='h3' textStyle='h3'>
        Beneficiary Bank
      </Text>
      <Stack spacing={4}>
        <Stack direction='row' w='100%' spacing={4}>
          {isInternationalBank && bankName && (
            <Box w='50%' data-testid='bankName'>
              <Text fontWeight='bold'>Bank Name</Text>
              <Text>{bankName}</Text>
            </Box>
          )}
          <Box w='50%'>
            <Text fontWeight='bold'>{isInternationalBank ? 'Bank SWIFT / BIC' : 'Bank ABA Routing / SWIFT / BIC'}</Text>
            <Text>{bankSWIFTBIC}</Text>
          </Box>
          {!isInternationalBank && (
            <Box w='50%'>
              <Text fontWeight='bold'>Intermediate Account</Text>
              <Text>{isIntermediaryAccount ? 'Yes' : 'No'}</Text>
            </Box>
          )}
        </Stack>

        {isInternationalBank && (
          <>
            <Stack direction='row' w='100%' spacing={4}>
              {(bankAddress.city || bankAddress.stateProvince || bankAddress.postalCode || bankAddress.country) && (
                <Box w='50%'>
                  <Text fontWeight='bold'>Address</Text>
                  <Stack spacing={0}>
                    {(bankAddress.city || bankAddress.stateProvince || bankAddress.postalCode) && (
                      <Text>
                        {bankAddress.city}
                        {bankAddress.stateProvince || bankAddress.postalCode ? `, ` : ''} {bankAddress.stateProvince}{' '}
                        {bankAddress.postalCode}
                      </Text>
                    )}
                    {bankAddress.country && <Text>{bankAddress.country}</Text>}
                  </Stack>
                </Box>
              )}
              <Box w='50%'>
                <Text fontWeight='bold'>Intermediate Account</Text>
                <Text>{isIntermediaryAccount ? 'Yes' : 'No'}</Text>
              </Box>
            </Stack>
          </>
        )}
        {isIntermediaryAccount && (
          <Box w='50%' data-testid='intermediateBank'>
            <Text fontWeight='bold'>Intermediate Bank</Text>
            <Stack spacing={0}>
              <Text>{name}</Text>
              <Text>{accountNumber}</Text>
              <Text>{address}</Text>
              {addressLine2 && <Text>{addressLine2}</Text>}
              <Text>
                {city}
                {stateProvince || postalCode ? ',' : ''} {stateProvince} {postalCode}
              </Text>
              <Text>{country}</Text>
            </Stack>
          </Box>
        )}
      </Stack>
    </Stack>
  )
}

export default BeneficiaryBankSection
